module.exports = __webpack_public_path__ + "static/img/logo-left-bottom.8cd1184.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/logo-left-bottom.png
// module id = VrVp
// module chunks = 1